import React from 'react'
import * as C from "../componentsM/index";

const GettingInvolved = () => {
    return (
        <>

            <C.Hero title={"GETTING INVOLVED"} image={"/hero/GETTING.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <h1 className="font-semibold">
                        There is a vibrant Parent Board and they are constantly looking for volunteers for special projects and events including:
                    </h1>



                    <ul className="list-disc list-inside my-2">
                        {[
                            "International Day in school.",
                            "Teachers’ Appreciation Day",
                            "Meet the Candidates’ Night (New Board Candidates)",
                            "Being an Open Forum for the Board of the school.",
                            "Raising funds either through dues or fundraising activities of teachers or students.",
                            "Field trips",
                            "Chaperoning teen-agers",
                            "Housing coordination for conventions.",
                            "Transportation coordination/carpooling",
                            "To liaise with the school-administration concerning the hygiene and quality of food at the school cafeteria",
                            "Substitute Teaching programme"
                        ]
                            .map(v => <li key={v} className='my-2 font-bold'>{v}</li>)}
                    </ul>



                    <h1 className="text-xl md:text-3xl">This list is not exhaustive.</h1>

                    <h6 className='font-semibold md:text-xl'>The Parent Board aims at being a vehicle of communication between the parents and the school in order to:</h6>


                    <ol className=" my-2">
                        {[
                            "1. Maintain and enhance the level of confidence between teachers, administration and parents;",
                            "2. Assisting the school to meet its administrative and programme needs;",
                            "3. To assist the parents at participating closer in extra-curricular activities.",
                            "4. To promote the International Baccalaureate",
                            "5. To raise and disburse funds for scholarship and financial assistance"
                        ]


                            .map(v => <li key={v} className='my-2 font-bold'>{v}</li>)}
                    </ol>


                    <h6 className='font-semibold md:text-xl'>
                        For further details please review Memorandum of Association, By-Laws and Constitution of Parent Board and contact the President of the Parent Board.</h6>

                </div>


            </section>

        </>
    )
}

export default GettingInvolved